import { useEffect, useState } from 'react';
import {
  webSerial,
  WebSerialState
} from '../services/printer/local/web-serial.service';

/** Live printer connection state for components. */
export const useLocalPrinter = (): WebSerialState => {
  const [state, setState] = useState<WebSerialState>(webSerial.getState());
  useEffect(() => webSerial.subscribe(setState), []);
  return state;
};
